import React from "react";

import { useTheme } from "../../../context/theme";
import { Box, Center } from "../../layout";
import { Text } from "../../typography";

export type ToggleOption<ValueT = string> = {
  value: ValueT;
  label: string;
};

type Props<ValueT> = ToggleOption<ValueT> & {
  selectedValue: ValueT;
  onChange: (value: ValueT) => void;
};

export default function ToggleOptionButton<ValueT = string>({
  selectedValue,
  onChange,
  value,
  label
}: Props<ValueT>) {
  const theme = useTheme();

  const active = selectedValue === value;

  return (
    <Box
      component="button"
      onClick={() => onChange(value)}
      width="100%"
      height="32px"
      backgroundColor={active ? theme.foreground : "transparent"}
      borderRadius="small"
      border="none"
      outline="none"
      minWidth="100px"
      paddingX="xlarge"
      cursor={active ? "auto" : "pointer"}
    >
      <Center>
        <Text
          size="small"
          tone={active ? "primary" : "neutral"}
          emphasis={active ? "high" : "medium"}
        >
          {label}
        </Text>
      </Center>
    </Box>
  );
}
